module.exports = __webpack_public_path__ + "media/signup-react/gift-bbf2e671.png";